/**
 * @deprecated This file is kept for backward compatibility only.
 * All course data should be fetched from the database via UnifiedCourseService.
 * DO NOT ADD NEW COURSES HERE - use database migrations instead.
 */

import { DotNetCourse } from './types';
import { DOTNET_BASIC_MODULES } from './modules/dotnetBasicsModules';
import { DOTNET_INTERMEDIATE_MODULES } from './modules/dotnetIntermediateModules';
import { DOTNET_ADVANCED_MODULES } from './modules/dotnetAdvancedModules';

// .NET Basic Course (Level 1)
const DOTNET_BASIC_COURSE: DotNetCourse = {
  id: "dotnet-basic",
  title: ".NET Fundamentals",
  description: "Master the fundamentals of .NET development with C#, from basic syntax to building console applications.",
  level: "beginner",
  duration: "6-8 weeks",
  totalDuration: "35 hours",
  estimatedHours: 35,
  image: "/api/placeholder/400/300",
  prerequisites: [
    "Basic programming concepts",
    "Understanding of variables and control structures",
    "Familiarity with development environments"
  ],
  learningOutcomes: [
    "Understand .NET ecosystem and framework differences",
    "Write C# applications using OOP principles",
    "Handle errors and debug applications effectively",
    "Build interactive console applications",
    "Apply best practices for .NET development"
  ],
  modules: DOTNET_BASIC_MODULES
};

// .NET Intermediate Course (Level 2)
const DOTNET_INTERMEDIATE_COURSE: DotNetCourse = {
  id: "dotnet-intermediate",
  title: ".NET Web Development",
  description: "Build web applications using ASP.NET Core, Entity Framework, and modern development practices.",
  level: "intermediate",
  duration: "8-10 weeks",
  totalDuration: "45 hours",
  estimatedHours: 45,
  image: "/api/placeholder/400/300",
  prerequisites: [
    "Completion of .NET Fundamentals course",
    "Understanding of C# and OOP concepts",
    "Basic knowledge of HTML/CSS",
    "Familiarity with databases"
  ],
  learningOutcomes: [
    "Build web applications with ASP.NET Core",
    "Implement database operations with Entity Framework",
    "Handle authentication and authorization",
    "Deploy web applications to cloud platforms",
    "Apply advanced C# features and LINQ"
  ],
  modules: DOTNET_INTERMEDIATE_MODULES
};

// .NET Advanced Course (Level 3) - Now with modules!
const DOTNET_ADVANCED_COURSE: DotNetCourse = {
  id: "dotnet-advanced",
  title: ".NET Enterprise Development",
  description: "Master advanced .NET concepts including microservices, testing, and enterprise-grade applications.",
  level: "advanced",
  duration: "10-12 weeks",
  totalDuration: "60 hours",
  estimatedHours: 60,
  image: "/api/placeholder/400/300",
  prerequisites: [
    "Completion of .NET Web Development course",
    "Experience with ASP.NET Core and Entity Framework",
    "Understanding of web development principles",
    "Knowledge of databases and SQL"
  ],
  learningOutcomes: [
    "Architect microservices-based applications",
    "Implement comprehensive testing strategies",
    "Build real-time applications with SignalR",
    "Deploy to production with CI/CD pipelines",
    "Optimize application performance and security"
  ],
  modules: DOTNET_ADVANCED_MODULES
};

export const DOTNET_COURSES: DotNetCourse[] = [
  DOTNET_BASIC_COURSE,
  DOTNET_INTERMEDIATE_COURSE,
  DOTNET_ADVANCED_COURSE
];

// Export individual courses for backward compatibility
export {
  DOTNET_BASIC_COURSE,
  DOTNET_INTERMEDIATE_COURSE,
  DOTNET_ADVANCED_COURSE
};

// Export types and modules
export * from './types';
export * from './modules/dotnetBasicsModules';
export * from './modules/dotnetIntermediateModules';
export * from './modules/dotnetAdvancedModules';
